import { render } from "./Office.vue?vue&type=template&id=6a4722ae"
const script = {}

import exportComponent from "/home/blessed_fms/fms_employee_Portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__